import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
    customer: '',
    installAddr: '',
    phone1: '',
    phone2: '',
    billAddr: '',
  },
};

export const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    updateValue: (state, action) => {
      state.data[action.payload.id] = action.payload.value || '';
    },
    updateDataContact: (state, action) => {
      state.data = action.payload;
    },
    init: (state, action) => {
      state.data = initialState.data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateValue, updateDataContact, init } = contactSlice.actions;

export default contactSlice.reducer;
